import React, { Component, Fragment } from 'react'
import {
  Grid,
  Paper,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Drawer,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from '@material-ui/core'

import { onChangeEditHOF } from '../../utils/common'

import MetrcEmployeeKey from './MetrcEmployeeKey'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import SearchField from '../common/SearchField'
import { CompliancePage } from '../MfeParcels/CompliancePage'
import { metrcEnvironmentOptions as environmentOptions } from '../../utils/constants'
import { EditableSelect } from '../common/EditableComponents'
import SearchIcon from '@material-ui/icons/Search'
import { getMetrcFacilitiesDataSearchAPI } from '../../api/thirdParty'
import { MetrcEmployeeDrawer } from './MetrcEmployeeDrawer'

const MetrcEmployeeKeyEditable = EditableHOCWrapper(MetrcEmployeeKey)

export default class MetrcEmployees extends Component {
  onChange = onChangeEditHOF(this.props.onChange)
  state = {
    employee: null,
    environment: environmentOptions[1].value,
    facilities: [],
    facLicense: '',
  }

  onSave = (data, afterOnSave) => {
    this.props.onUpdateEmployeeKey(data, afterOnSave)
  }

  onSelectEmployee = (employee) => {
    this.setState({ employee }, () => {
      this.getFacilities()
    })
  }

  getFacilities = async () => {
    const { employee = {}, environment: env } = this.state
    const { userApiKey } = employee
    try {
      const facilitiesMap = await getMetrcFacilitiesDataSearchAPI(env, 'sc', userApiKey)
      this.setState({ facilities: facilitiesMap['sc'] || [] })
    } catch (_) {
      this.setState({ facilities: [] })
    }
  }

  render() {
    const {
      data,
      shop,
      metrcEmployeeKeys = [],
      searchTerm = '',
      onSearchEmployeeKey,
      onChangeTerm,
    } = this.props
    const { environment, facilities, facLicense, employee } = this.state

    return (
      <Fragment>
        <Grid container>
          <Grid className="list-container" item xs={12} sm={12} md={12} lg={12}>
            <SearchField
              onChange={onChangeTerm}
              value={searchTerm}
              onSearch={onSearchEmployeeKey}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Employee Name</TableCell>
                      <TableCell>Metrc API Key</TableCell>
                      <TableCell>API Permission</TableCell>
                      <TableCell>Enabled</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {metrcEmployeeKeys &&
                      metrcEmployeeKeys.map((row, index) => {
                        return (
                          <MetrcEmployeeKeyEditable
                            key={index}
                            lastModified={row.lastModified}
                            dataToEdit={row}
                            onSave={this.onSave}
                            onSelectEmployee={this.onSelectEmployee}
                            onDelete={() => {
                              this.props.onDelete(row)
                            }}
                            defaultEditMode={false}
                            employeeSelectedId={employee ? employee.employeeId : null}
                          />
                        )
                      })}

                    {employee && (
                      <MetrcEmployeeDrawer
                        employee={employee}
                        onClose={() => this.setState({ employee: null, facLicense: null })}
                        onChangeEnv={(event) => this.setState({ environment: event.target.value })}
                        onChangeFac={(event) => this.setState({ facLicense: event.target.value })}
                        facLicense={facLicense}
                        onSearch={() => this.getFacilities()}
                        environment={environment}
                        facilities={facilities}
                        shop={shop}
                      />
                    )}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Metrc/MetrcEmployees.js